import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import * as css from './Container.scss';

const Container = ({ className, children }) => <div className={classNames(css.container, className)}>{children}</div>;

Container.propTypes = {
	className: PropTypes.string,
	children: PropTypes.node,
};

Container.defaultProps = {
	className: '',
	children: null,
};

export default Container;
